const parallaxImageInit = (block) => {
    const images = block ? [block[0].querySelector(".bn-parallax-image")] : Array.from(
        document.querySelectorAll(".bn-parallax-image")
    );

    if (images) {
        const layers = document.querySelectorAll(".parallax-layer");

        const isInViewport = (element) => {
            const rect = element.getBoundingClientRect();
            return rect.top < window.innerHeight && rect.bottom > 0;
        };

        let mouseX = 0;
        let mouseY = 0;
        let smoothMouseX = 0;
        let smoothMouseY = 0;
        let smoothScrollY = 0;
        let targetScrollY = 0;

        const lerp = (start, end, factor) => start + (end - start) * factor;

        const updateSmoothValues = () => {
            smoothMouseX = lerp(smoothMouseX, mouseX, 0.1);
            smoothMouseY = lerp(smoothMouseY, mouseY, 0.1);
            smoothScrollY = lerp(smoothScrollY, targetScrollY, 0.05); // Zmniejszenie prędkości scrolla
        };

        const handleScroll = () => {
            targetScrollY = window.scrollY;

            layers.forEach((layer) => {
                const rect = layer.getBoundingClientRect();
                const layerSpeed =
                    parseFloat(layer.getAttribute("data-speed")) || 1;

                if (isInViewport(layer)) {
                    const offsetTop = rect.top - window.innerHeight * 0.5;
                    const scrollOffsetY = offsetTop * (layerSpeed / 3); // Zmniejszenie prędkości parallaxa na scrollu

                    const translateX = smoothMouseX * layerSpeed * 160;
                    let translateY =
                        scrollOffsetY + smoothMouseY * layerSpeed * 160;

                    if (layer.hasAttribute("data-limit-to-top")) {
                        const limit = parseFloat(layer.getAttribute("data-limit-to-top"));
                        translateY = translateY < limit ? limit : translateY; 
                    }

                    layer.style.transition = "transform 0.2s ease-out"; // Smooth scroll dla transformacji
                    layer.style.transform = `translate(${translateX}px, ${translateY}px)`;
                }
            });
        };

        const animate = () => {
            updateSmoothValues();
            handleScroll();
            requestAnimationFrame(animate);
        };

        window.addEventListener("scroll", () => {
            targetScrollY = window.scrollY;
        });

        handleScroll();
        animate();
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (document.body && !document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        parallaxImageInit();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/parallax-image', parallaxImageInit);
});